import { point } from "@turf/helpers";
import booleanPointInPolygon from "@turf/boolean-point-in-polygon";
import lineSegment from "@turf/line-segment";
import pointToLineDistance from "@turf/point-to-line-distance";

export function getClosestCountryIso(lat, lon, geoJson) {
  if (!geoJson?.features?.length) return null;

  const pt = point([lon, lat]);

  // 1. Exact containing polygon
  for (const feature of geoJson.features) {
    if (booleanPointInPolygon(pt, feature)) {
      return feature.properties?.iso || null;
    }
  }

  // 2. Otherwise find nearest polygon edge
  let closestIso = null;
  let closestDistance = Infinity;

  for (const feature of geoJson.features) {
    const iso = feature.properties?.iso;
    if (!iso) continue;

    try {
      const segments = lineSegment(feature);

      let featureMinDistance = Infinity;

      for (const segment of segments.features) {
        const distance = pointToLineDistance(pt, segment, {
          units: "kilometers",
        });

        if (distance < featureMinDistance) {
          featureMinDistance = distance;
        }
      }

      if (featureMinDistance < closestDistance) {
        closestDistance = featureMinDistance;
        closestIso = iso;
      }
    } catch (error) {
      console.warn("Failed distance check for feature:", iso, error);
    }
  }

  return closestIso;
}
